import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Select from '../Select';
import { paginationClass } from './styles';
import { getDirectionClass } from '../utils/classname';
var DefaultValue = {
  pageSizeList: [10, 20, 30, 50, 100]
};

var PageSizeList =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PageSizeList, _PureComponent);

  var _super = _createSuper2(PageSizeList);

  function PageSizeList(props) {
    var _this;

    _classCallCheck(this, PageSizeList);

    _this = _super.call(this, props);
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PageSizeList, [{
    key: "handleChange",
    value: function handleChange(pageSize) {
      var _this$props = this.props,
          current = _this$props.current,
          onChange = _this$props.onChange;
      var start = (current - 1) * this.props.pageSize + 1;
      onChange(Math.ceil(start / pageSize), pageSize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          pageSize = _this$props2.pageSize,
          _this$props2$pageSize = _this$props2.pageSizeList,
          pageSizeList = _this$props2$pageSize === void 0 ? DefaultValue.pageSizeList : _this$props2$pageSize,
          text = _this$props2.text,
          disabled = _this$props2.disabled,
          size = _this$props2.size,
          _this$props2$sizeList = _this$props2.sizeListProps,
          sizeListProps = _this$props2$sizeList === void 0 ? {} : _this$props2$sizeList;
      return (
        /*#__PURE__*/
        React.createElement(Select, Object.assign({
          onChange: this.handleChange,
          disabled: disabled,
          absolute: true,
          autoAdapt: true,
          keygen: true,
          value: pageSize,
          size: size,
          className: paginationClass(getDirectionClass('section'), 'pagesize'),
          data: pageSizeList,
          renderItem: function renderItem(d) {
            return "".concat(d, " ").concat(text.page || '');
          }
        }, sizeListProps))
      );
    }
  }]);

  return PageSizeList;
}(PureComponent);

PageSizeList.defaultProps = DefaultValue;
export default PageSizeList;